<script>
    export let size = 24
    export let color = '#00669E'
    export let style = ''
    export let title = null
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={`${size}`}
    height={`${size}`}
    fill={color}
    {style}
>
    {#if title}
        <title>{title}</title>
    {/if}
    <polygon points="103 464 48 464 48 409 358.14 98.09 413.91 153.87 103 464"
    ></polygon>
    <path
        d="M425.72,142,370,86.28l31.66-30.66C406.55,50.7,414.05,48,421,48a25.91,25.91,0,0,1,18.42,7.62l17,17A25.87,25.87,0,0,1,464,91c0,7-2.71,14.45-7.62,19.36ZM418.2,71.17h0Z"
    ></path>
</svg>
